import { SVGProps } from 'react';

const CirclePlus = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="10.0001"
      cy="10.0001"
      r="8.44444"
      stroke="#29F085"
      stroke-width="2"
    />
    <rect
      x="9.05566"
      y="5.27783"
      width="1.41667"
      height="9.44444"
      fill="#29F085"
    />
    <rect
      x="5.27783"
      y="10.9443"
      width="1.41667"
      height="9.44444"
      transform="rotate(-90 5.27783 10.9443)"
      fill="#29F085"
    />
  </svg>
);

export default CirclePlus;
